export default function useFormatMoney() {
    
    const baseOptions = {
        minimumFractionDigits: 2, 
        maximumFractionDigits: 2, 
    };
    const formatterMoney = (monto, showSymbol = true, type = 'es-PE',) =>{

        let opciones = { ...baseOptions };

        if (showSymbol) {
            opciones.style = 'currency';
            opciones.currency = 'PEN';
        }
        const formatterPE = new Intl.NumberFormat(type, opciones);
        return monto ? formatterPE.format(monto) : "";
    }

  return {
    formatterMoney
  }
}